
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Menu } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { solucoes } from "@/data/solucoes";

const MobileMenu = () => {
  const { user, signOut } = useAuth();

  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="ghost" className="flex md:hidden" aria-label="Abrir menu de navegação">
          <Menu className="h-6 w-6" />
        </Button>
      </SheetTrigger>
      <SheetContent side="left" className="w-[280px] sm:w-[320px] p-0 flex flex-col">
        {/* Logo */}
        <div className="p-6 pb-4 border-b border-border">
          <Link to="/" className="flex items-center">
            <img
              src="https://qfozcnxbtjjmidhjdepc.supabase.co/storage/v1/object/public/Peca%20Email/Logo%20Nome.png"
              alt="AmeUp"
              className="h-8 w-auto"
            />
          </Link>
        </div>

        <nav className="flex flex-col flex-1 py-4 overflow-y-auto">
          {/* User section at top */}
          <div className="px-6 pb-4">
            {user ? (
              <div className="flex flex-col gap-2">
                <Link
                  to="/fornecedor/painel/inicio"
                  className="block w-full text-center text-sm font-medium text-foreground bg-accent hover:bg-accent/80 rounded-lg py-2.5 transition-colors"
                >
                  Meu Perfil
                </Link>

                <button
                  onClick={signOut}
                  className="w-full text-center text-sm text-destructive hover:bg-destructive/10 rounded-lg py-2.5 transition-colors"
                >
                  Sair
                </button>
              </div>
            ) : (
              <Link
                to="/login"
                className="block w-full text-center text-sm font-medium text-primary border border-primary hover:bg-primary/10 rounded-lg py-2.5 transition-colors"
              >
                Entrar
              </Link>
            )}
          </div>

          <div className="border-t border-border" />

          <div className="px-6 py-4">
            <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
              Soluções AmeUp
            </span>
          </div>
          {solucoes.map((s) => (
            <Link
              key={s.slug}
              to={`/solucoes/${s.slug}`}
              className="px-6 py-2.5 text-sm text-foreground hover:bg-accent transition-colors"
            >
              {s.title}
            </Link>
          ))}

          <div className="my-2 mx-4 border-t border-border" />

          <Link
            to="/materiais-gratuitos"
            className="px-6 py-3 text-sm text-foreground hover:bg-accent transition-colors"
          >
            Materiais Gratuitos
          </Link>

          <Link
            to="/blog"
            className="px-6 py-3 text-sm text-foreground hover:bg-accent transition-colors"
          >
            Blog
          </Link>
        </nav>
      </SheetContent>
    </Sheet>
  );
};

export default MobileMenu;
